const scope = "te";
export default scope;
